import {  createSlice } from "@reduxjs/toolkit"
import { stateEnum } from "../constants/enum.js"

const { challanEntry } = stateEnum

const initialState = {
  detailParams: {},
  isNewEntry: false,
}


const challanEntrySlice = createSlice({
  name: challanEntry,
  initialState,
  reducers: {
   
    setNewEntryMode: (state, action) => {
      state.isNewEntry = action.payload
    },
    setDetailParams: (state, action) => {
      state.detailParams = action.payload
    },
    resetDetailParams: (state) => {
      state.detailParams = {}
      state.isNewEntry = true

    },
  },
  
})

export const {  setDetailParams, resetDetailParams, setNewEntryMode } = challanEntrySlice.actions
export default challanEntrySlice.reducer
